var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "124.466px",
    viewBox: "0 0 613.559 124.466",
    enableBackground: "new 0 0 613.559 124.466",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 613.559,
    height: 124.466
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 613.559,
    height: 124.466
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#C9E2A4",
    d: "M613.56,113.372L612.713,6.868c0,0-27.082-14.607-52.47-1.217 c-25.389,13.391-42.314,14.609-57.548,13.391c-15.233-1.217-27.081,2.436-32.159,7.306c-5.078,4.869-15.232,9.738-35.544,9.738 c-13.541,0-11.848,4.869-15.232,8.521c-3.386,3.652-13.541,8.521-38.93,0.338c0,0-25.389-8.859-59.241,13.053 c-33.851,21.913-54.162,19.479-71.087,12.174c-16.926-7.304-27.081-18.261-64.318-14.607 c-34.986,3.431-54.365,16.756-84.629,12.173C69.778,62.927,57.973,39.986,0.152,50.584L0,50.694v25.273 c0,0,23.696-4.577,47.392,12.466c23.696,17.043,59.24,14.178,99.862,7.304s60.933-6.004,79.551,0 c18.618,6.005,50.129,27.07,111.334,26.635c54.191-0.385,66.3-24.154,114.383-9c34.115,10.752,63.212,16,92.31,5 C563.186,111.435,590.986,105.372,613.56,113.372"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M560.243,5.651c-25.388,13.392-42.315,14.608-57.548,13.392c-15.233-1.218-27.081,2.434-32.159,7.304 s-15.232,9.739-35.544,9.739c-13.54,0-11.849,4.87-15.233,8.521s-13.54,8.521-38.929,0.339c0,0-25.389-8.86-59.24,13.053 c-33.852,21.912-54.163,19.478-71.089,12.174c-16.926-7.305-27.08-18.261-64.317-14.609 c-34.987,3.432-54.366,16.758-84.63,12.175C69.779,62.927,57.973,39.987,0.152,50.585L0,50.694v25.273 c0,0,23.696-4.578,47.392,12.466c23.696,17.043,59.24,14.177,99.862,7.305c40.622-6.874,60.933-6.006,79.551,0 c18.619,6.004,50.129,27.068,111.333,26.635c54.193-0.386,66.301-24.156,114.385-9c20.816,6.561,39.772,11.073,57.993,11.093 h0.211c11.563-0.009,22.832-1.832,34.104-6.094c18.353-6.938,46.154-13,68.727-5v-0.113l-0.846-106.39 c0,0-12.736-6.868-28.924-6.869C576.367,0,568.223,1.441,560.243,5.651"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -9.188,
    y: -17.128,
    width: 631.249,
    height: 218.32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_8_)",
    fill: "#FFFFFF",
    d: "M613.061,7.079c0,0-79.16-39-145.296,4c-66.135,43-75.152,107-141.288,106 c-66.134-1-103.302-50.654-133.271-53c-44.09-3.451-85.174,33-129.264,3c0,0-17.034-13-27.055-26 c-10.02-13-21.043-27-37.075-35v69c0,0,29.059-7,52.106,8c14.293,9.302,61.124,29,100.204,16c0,0,29.059-7.978,55.112,18.511 c26.053,26.489,87.178,57.489,152.311,19.489c65.132-38,84.171-23,108.22-7c24.05,16,80.163,73,145.296,70V7.079z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLayer);
export default __webpack_public_path__ + "static/media/banner-layer.0b6dcc04f5d63078bc782ad902c9ef7b.svg";
export { ForwardRef as ReactComponent };